module.exports = __webpack_public_path__ + "static/media/mission-dormant-ac-ic.43428287.svg";